// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"755e6724","150":"755e6724","226":"755e6724","325":"755e6724","475":"755e6724","536":"6085bc6a","606":"755e6724","904":"755e6724"}[chunkId] + ".chunk.css";
};